import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { mdiMenuDown, mdiPrinter } from '@mdi/js';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import IconTextoNorma from '@/views/components/icons/IconTextoNorma.vue';

interface IProps {
  items?: IItem[];
  disabled?: boolean;
  color?: string;
  returnObject?: boolean;
}

interface IItem {
  text: string;
  value: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icone: any;
}

interface IEmits {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (event: 'change', e: any): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SeletorOpcoesImpressão',
  props: {
    items: { default: () => [
    {
      text: 'Simplificado',
      value: 'S',
      icone: IconPaginaSimplificada,
    },
    {
      text: 'Detalhado',
      value: 'D',
      icone: IconPaginaDetalhada,
    },
    {
      text: 'Texto da norma',
      value: 'T',
      icone: IconTextoNorma,
    },
  ] },
    disabled: { type: Boolean },
    color: { default: 'primary' },
    returnObject: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (event: 'change', e: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { items: IItem[], disabled?: boolean, color: string, returnObject?: boolean };

const itemSelected = ref<IItem | null>(null);





const setItem = (item: IItem) => {
  itemSelected.value = item;

  if (props.returnObject) {
    return emit('change', itemSelected.value);
  }
  return emit('change', itemSelected.value.value);
};

return { __sfc: true,itemSelected, props, emit, setItem, mdiMenuDown, mdiPrinter }
}

})